import { requestBlob, requestJSON } from '@/api/client'
import type { Condition } from '@/lib/expr'
import type { Dashboard, DateRangeSpec, Layout, Widget, WidgetResult } from './model'

const q = encodeURIComponent

export interface DashboardInput {
    name: string
    description: string
    shared: 'private' | 'org'
    layout: Layout
}

export interface QueryOverrides {
    filters?: Condition
    dateRange?: DateRangeSpec
}

export const dashboardApi = {
    list: () => requestJSON<{ items: Dashboard[] }>('GET', '/api/dashboards').then((r) => r.items),
    get: (id: string) =>
        requestJSON<{ dashboard: Dashboard; can_edit: boolean }>('GET', `/api/dashboards/${q(id)}`),
    create: (d: DashboardInput) => requestJSON<Dashboard>('POST', '/api/dashboards', d),
    update: (id: string, d: DashboardInput) => requestJSON<Dashboard>('PUT', `/api/dashboards/${q(id)}`, d),
    remove: (id: string) => requestJSON<void>('DELETE', `/api/dashboards/${q(id)}`),
    query: (id: string, overrides: QueryOverrides = {}, widgetId?: string) =>
        requestJSON<{ dashboardId: string; results: WidgetResult[] }>(
            'POST', `/api/dashboards/${q(id)}/query${widgetId ? `?widget=${q(widgetId)}` : ''}`, overrides),
    previewWidget: (spec: Widget) => requestJSON<WidgetResult>('POST', '/api/dashboards/preview-widget', spec),
    exportCsv: (id: string, widgetId: string) =>
        requestBlob(`/api/dashboards/${q(id)}/widgets/${q(widgetId)}/export.csv`),
}
